import { CommonModule } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'
import { Component, effect } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { AuthService } from '../../../services/auth.service'
import { CardModule } from 'primeng/card'
import { ButtonModule } from 'primeng/button'
import { ResponsiveLogoComponent } from '../../../components/commons/responsive-logo/responsive-logo.component'
import { Tag } from 'primeng/tag'
import { UtilsService } from '../../../services/utils/utils.service'
import { PortabilityRequestsFilesConfigService } from '../../../services/portability-request.services/portability-requests-files-config.service copy'

@Component({
  selector: 'app-login-callback-page',
  imports: [
    CommonModule,
    TranslateModule,
    CardModule,
    ButtonModule,
    ResponsiveLogoComponent,
    Tag,
  ],
  templateUrl: './login-callback.component.html',
  styleUrl: './login-callback.component.scss',
})
export class LoginCallbackComponent {
  constructor(
    private router: Router,
    private authService: AuthService,
    private portabilityRequestsFilesConfigService: PortabilityRequestsFilesConfigService,
    private activeRoute: ActivatedRoute,
    private utilsService: UtilsService,
  ) {
    effect(() => {
      if (this.authService.isLoggedIn()) {
        this.portabilityRequestsFilesConfigService.fetchPortabilityRequestFilesConfig()

        this.router.navigate(['/'])
      }
    })
  }

  async ngOnInit() {
    this.utilsService.initPageTitle('LOGIN.REDIRECTION_WAITING_MESSAGE')

    if (this.activeRoute.snapshot.queryParams['code']) {
      await this.authService.handleAuthentication()
    }
  }
}
